export default __webpack_public_path__ + "static/working-on-sofa-d1c6b1e36cfd4be248311166f645bd6f.svg";